export default "__VITE_ASSET__QlwqaBC9__"